/* RHOOTS · Redesign 2026 · Skript für die rhoots-Sections
   Wird von jeder rhoots-Section geladen, läuft aber nur einmal. */
(function () {
  if (window.Rhoots) return;
  var R = (window.Rhoots = {});

  R.money = function (cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'de-DE', { style: 'currency', currency: cur }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2).replace('.', ',') + ' €';
    }
  };

  /* ---------- In den Warenkorb, passend zum Warenkorb-Drawer von Wonder ---------- */
  R.addToCart = function (formData, trigger) {
    var drawer = document.querySelector('cart-drawer');
    var useDrawer = drawer && typeof drawer.renderContents === 'function' && drawer.dataset.cartType !== 'page';
    if (useDrawer) {
      formData.append('sections', drawer.getSectionsToRender().map(function (s) { return s.id; }));
      formData.append('sections_url', window.location.pathname);
      if (drawer.setActiveElement) drawer.setActiveElement(trigger || document.activeElement);
    }
    var url = (window.routes && window.routes.cart_add_url) || '/cart/add';
    return fetch(url, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body: formData
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) throw new Error(res.description || res.message || 'Fehler');
        if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'rhoots', productVariantId: formData.get('id'), cartData: res });
        }
        if (useDrawer) {
          drawer.classList.remove('is-empty');
          var closed = !document.body.classList.contains('page-overlay-cart-on');
          /* Wonder will u. a. das Warenkorb-Symbol im alten Header aktualisieren.
             Ist der alte Header ausgeblendet (Rhoots Header), fehlt dieses Element:
             dann einen unsichtbaren Platzhalter anlegen, damit nichts abbricht. */
          try {
            (drawer.getSectionsToRender() || []).forEach(function (sec) {
              var el = sec.selector ? document.querySelector(sec.selector) : document.getElementById(sec.id);
              if (!el && (!sec.selector || /^#[\w-]+$/.test(sec.selector))) {
                var ph = document.createElement('div');
                ph.id = sec.selector ? sec.selector.slice(1) : sec.id;
                ph.hidden = true;
                document.body.appendChild(ph);
              }
            });
            drawer.renderContents(res, closed);
          } catch (err) {
            if (typeof drawer.open === 'function') { try { drawer.open(); } catch (e2) { window.location = (window.routes && window.routes.cart_url) || '/cart'; } }
            else window.location = (window.routes && window.routes.cart_url) || '/cart';
          }
        } else {
          window.location = (window.routes && window.routes.cart_url) || '/cart';
        }
        if (R.refreshCartCount) R.refreshCartCount();
        return res;
      });
  };

  /* ---------- Quick-Add (+) auf den Produktkacheln ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('[data-rhoots-quick-add]')) return;
    e.preventDefault();
    var btn = form.querySelector('button');
    if (btn) btn.classList.add('is-loading');
    R.addToCart(new FormData(form), btn)
      .then(function () {
        if (!btn) return;
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        setTimeout(function () { btn.classList.remove('is-added'); }, 1600);
      })
      .catch(function (err) {
        if (btn) btn.classList.remove('is-loading');
        R.toast(err.message);
      });
  });

  R.toast = function (msg) {
    var t = document.createElement('div');
    t.className = 'r-toast';
    t.setAttribute('role', 'status');
    t.textContent = msg;
    document.body.appendChild(t);
    setTimeout(function () { t.remove(); }, 3500);
  };

  /* ---------- Videos: nur abspielen, wenn sichtbar ---------- */
  function initVideos(root) {
    var vids = (root || document).querySelectorAll('[data-rhoots-autoplay] video');
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else v.pause();
      });
    }, { threshold: 0.2 });
    vids.forEach(function (v) { v.muted = true; io.observe(v); });
  }

  /* ---------- Anleitung: Clips nacheinander abspielen ---------- */
  function initSequences(root) {
    var lists = (root || document).querySelectorAll('[data-rhoots-sequence]:not([data-ready])');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    lists.forEach(function (list) {
      list.setAttribute('data-ready', '');
      if (reduce || !('IntersectionObserver' in window)) return;
      var steps = Array.prototype.slice.call(list.querySelectorAll('.r-step'));
      if (!steps.length) return;
      var hold = (parseFloat(list.getAttribute('data-hold')) || 2.5) * 1000;
      var idx = 0, timer = null, raf = null, running = false, touched = false;
      list.addEventListener('pointerdown', function () { touched = true; });

      function bar(step) { return step.querySelector('.r-step__bar span'); }
      function video(step) { return step.querySelector('.r-step__media video'); }
      function stop() {
        running = false;
        list.classList.remove('is-running');
        clearTimeout(timer); cancelAnimationFrame(raf);
        steps.forEach(function (s) { var v = video(s); if (v) v.pause(); });
      }
      function play(i) {
        idx = i % steps.length;
        clearTimeout(timer); cancelAnimationFrame(raf);
        steps.forEach(function (s, n) {
          s.classList.toggle('is-active', n === idx);
          var b = bar(s); if (b && n !== idx) b.style.width = '0';
          var v = video(s); if (v && n !== idx) v.pause();
        });
        var step = steps[idx];
        if (!touched && list.scrollWidth > list.clientWidth + 4) {
          list.scrollTo({ left: step.offsetLeft - list.offsetLeft, behavior: 'smooth' });
        }
        var b = bar(step), v = video(step), start = performance.now();
        if (v) {
          v.muted = true; v.loop = false; v.currentTime = 0;
          var p = v.play(); if (p && p.catch) p.catch(function () { timer = setTimeout(function () { play(idx + 1); }, hold); });
          v.onended = function () { if (running) play(idx + 1); };
        } else {
          timer = setTimeout(function () { if (running) play(idx + 1); }, hold);
        }
        (function tick() {
          if (!running) return;
          var f = v && v.duration ? v.currentTime / v.duration : (performance.now() - start) / hold;
          if (b) b.style.width = Math.min(100, f * 100) + '%';
          raf = requestAnimationFrame(tick);
        })();
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting && !running) { running = true; list.classList.add('is-running'); play(idx); }
          else if (!en.isIntersecting && running) stop();
        });
      }, { threshold: 0.35 });
      io.observe(list);
    });
  }

  /* ---------- Video-Modal (Gründerinnen, Ear Seeding 101) ---------- */
  document.addEventListener('click', function (e) {
    var open = e.target.closest && e.target.closest('[data-rhoots-modal-open]');
    if (open) {
      var m = document.getElementById(open.getAttribute('data-rhoots-modal-open'));
      if (!m) return;
      m.classList.add('is-open');
      var v = m.querySelector('video');
      if (v) { v.currentTime = 0; v.play(); }
      var c = m.querySelector('.r-modal__close');
      if (c) c.focus();
      return;
    }
    var close = e.target.closest && (e.target.closest('.r-modal__close') || (e.target.classList.contains('r-modal') ? e.target : null));
    if (close) {
      var modal = close.closest('.r-modal');
      modal.classList.remove('is-open');
      var vv = modal.querySelector('video');
      if (vv) vv.pause();
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.r-modal.is-open').forEach(function (m) {
      m.classList.remove('is-open');
      var v = m.querySelector('video');
      if (v) v.pause();
    });
  });

  /* ---------- Produktseite ---------- */
  function initProduct(root) {
    var el = (root || document).querySelector('[data-rhoots-product]:not([data-ready])');
    if (!el) return;
    el.setAttribute('data-ready', '');
    var dataEl = el.querySelector('[data-rhoots-variants]');
    var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
    var form = el.querySelector('form[data-rhoots-product-form]');
    if (!form) return;
    var idInput = form.querySelector('input[name="id"]');
    var qtyInput = el.querySelector('[data-rhoots-qty]');
    var atc = form.querySelector('[data-rhoots-atc]');
    var atcLabel = atc ? atc.querySelector('[data-label]') : null;
    var atcTotal = atc ? atc.querySelector('[data-total]') : null;
    var priceEl = el.querySelector('[data-rhoots-price]');
    var compareEl = el.querySelector('[data-rhoots-compare]');
    var errorEl = el.querySelector('[data-rhoots-error]');
    var sticky = document.querySelector('[data-rhoots-sticky]');
    var labels = { add: atc ? atc.getAttribute('data-add') : 'In den Warenkorb', soldout: atc ? atc.getAttribute('data-soldout') : 'Ausverkauft' };

    function current() {
      var id = parseInt(idInput.value, 10);
      return variants.find(function (v) { return v.id === id; }) || variants[0];
    }
    function planPrice(v) {
      var plan = el.querySelector('input[name="selling_plan"]:checked');
      if (plan && plan.value && v.plans && v.plans[plan.value] != null) return v.plans[plan.value];
      return v.price;
    }
    function update() {
      var v = current();
      if (!v) return;
      var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
      var unit = planPrice(v);
      if (priceEl) {
        var txt = R.money(unit);
        if (priceEl.textContent !== txt) {
          priceEl.textContent = txt;
          priceEl.classList.remove('r-bump'); void priceEl.offsetWidth; priceEl.classList.add('r-bump');
        }
      }
      if (compareEl) {
        compareEl.textContent = v.compare > unit ? R.money(v.compare) : '';
        compareEl.hidden = !(v.compare > unit);
      }
      if (atc) {
        atc.disabled = !v.available;
        if (atcLabel) atcLabel.textContent = v.available ? labels.add : labels.soldout;
        if (atcTotal) atcTotal.textContent = v.available ? ' · ' + R.money(unit * qty) : '';
      }
      if (sticky) {
        var sp = sticky.querySelector('[data-sticky-price]');
        if (sp) sp.textContent = R.money(unit);
        var sb = sticky.querySelector('button');
        if (sb) sb.disabled = !v.available;
      }
      if (v.media) {
        var media = el.querySelector('[data-media-id="' + v.media + '"]');
        var gallery = el.querySelector('.r-pdp__gallery');
        if (media && gallery && media !== gallery.firstElementChild) {
          if (window.matchMedia('(max-width: 749px)').matches) gallery.scrollTo({ left: media.offsetLeft, behavior: 'smooth' });
          else gallery.insertBefore(media, gallery.firstElementChild);
        }
      }
    }

    el.addEventListener('change', function (e) {
      if (e.target.name === 'rhoots-group') {
        var groups = el.querySelectorAll('.r-subopts');
        var pickedId = e.target.getAttribute('data-first');
        groups.forEach(function (g) {
          var on = g.getAttribute('data-group') === e.target.value;
          g.hidden = !on;
          if (on) {
            var sel = g.querySelector('input[name="rhoots-variant"]:checked') || g.querySelector('input[name="rhoots-variant"]:not(:disabled)');
            if (sel) { sel.checked = true; pickedId = sel.value; }
          }
        });
        idInput.value = pickedId;
      }
      if (e.target.name === 'rhoots-variant' || e.target.name === 'rhoots-group') {
        if (e.target.name === 'rhoots-variant') idInput.value = e.target.value;
        if (window.history.replaceState) {
          var u = new URL(window.location.href);
          var cv = current();
          if (cv && cv.own) u.searchParams.set('variant', idInput.value);
          else u.searchParams.delete('variant');
          window.history.replaceState({}, '', u.toString());
        }
      }
      update();
    });
    el.addEventListener('click', function (e) {
      var b = e.target.closest('[data-rhoots-step]');
      if (!b || !qtyInput) return;
      var n = (parseInt(qtyInput.value, 10) || 1) + parseInt(b.getAttribute('data-rhoots-step'), 10);
      qtyInput.value = Math.min(99, Math.max(1, n));
      update();
    });
    if (qtyInput) qtyInput.addEventListener('input', update);

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!atc || atc.disabled) return;
      if (errorEl) errorEl.hidden = true;
      atc.setAttribute('aria-busy', 'true');
      var fd = new FormData(form);
      if (qtyInput) fd.set('quantity', qtyInput.value);
      R.addToCart(fd, atc)
        .then(function () {
          atc.classList.remove('is-added'); void atc.offsetWidth; atc.classList.add('is-added');
          setTimeout(function () { atc.classList.remove('is-added'); }, 900);
        })
        .catch(function (err) {
          if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
        })
        .finally(function () { atc.removeAttribute('aria-busy'); });
    });

    if (sticky && atc && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var en = entries[0];
        var past = !en.isIntersecting && en.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', past);
      });
      io.observe(atc);
      var sbtn = sticky.querySelector('button');
      if (sbtn) sbtn.addEventListener('click', function () { form.requestSubmit ? form.requestSubmit() : atc.click(); });
    }
    update();
  }


  /* Einblenden beim Scrollen: nur Elemente, die beim Laden noch unterhalb des Bildschirms liegen */
  var REVEAL = '.r-section h2, .r-section .r-label, .r-section .r-sub, .r-card, .r-set, .r-step, .r-topic, .r-ugc__item, .r-icon, .r-box__row, .r-stat, .r-logos__item, .r-compare-wrap, .r-quote__text, .r-statement__text, .r-ex__img, .r-faq-group, .r-it__media';
  function initReveal(root) {
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var scope = root || document;
    var els = Array.prototype.slice.call(scope.querySelectorAll(REVEAL)).filter(function (el) {
      return !el.closest('[data-rhoots-product]') && !el.closest('.r-hero') && !el.closest('.r-ugc--slider') && !el.classList.contains('r-reveal');
    });
    var vh = window.innerHeight || 800;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target;
        el.classList.add('is-in');
        io.unobserve(el);
        var d = parseInt(el.style.getPropertyValue('--r-delay'), 10) || 0;
        setTimeout(function () { el.classList.remove('r-reveal', 'is-in'); el.style.removeProperty('--r-delay'); }, 800 + d);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) {
      if (el.getBoundingClientRect().top < vh * 0.92) return;
      var sibs = el.parentElement ? Array.prototype.filter.call(el.parentElement.children, function (c) { return c.matches(REVEAL); }) : [];
      var i = Math.max(0, sibs.indexOf(el));
      el.style.setProperty('--r-delay', Math.min(i, 5) * 80 + 'ms');
      el.classList.add('r-reveal');
      io.observe(el);
    });
  }

  /* ---------- Slider (Community-Videos): Pfeile blättern um eine Seite ---------- */
  function initSliders(root) {
    (root || document).querySelectorAll('[data-rhoots-slider]').forEach(function (wrap) {
      if (wrap.dataset.ready) return;
      wrap.dataset.ready = '1';
      var track = wrap.querySelector('[data-slider-track]');
      var nav = wrap.querySelector('[data-slider-nav]');
      if (!track || !nav) return;
      var prev = nav.querySelector('[data-dir="-1"]');
      var next = nav.querySelector('[data-dir="1"]');
      function update() {
        var max = track.scrollWidth - track.clientWidth;
        nav.hidden = max < 4;
        prev.disabled = track.scrollLeft <= 4;
        next.disabled = track.scrollLeft >= max - 4;
      }
      function go(dir) {
        var item = track.firstElementChild;
        var step = item ? item.getBoundingClientRect().width + 16 : track.clientWidth;
        var per = Math.max(1, Math.round(track.clientWidth / step));
        track.scrollBy({ left: dir * step * per, behavior: 'smooth' });
      }
      prev.addEventListener('click', function () { go(-1); });
      next.addEventListener('click', function () { go(1); });
      track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  /* ---------- Header: Suche, Menü-Drawer, Warenkorb-Zähler ---------- */
  function initHeader(root) {
    (root || document).querySelectorAll('[data-rhoots-header]').forEach(function (h) {
      if (h.dataset.ready) return;
      h.dataset.ready = '1';
      var sBtn = h.querySelector('[data-r-search-toggle]');
      var sBox = h.querySelector('[data-r-search]');
      if (sBtn && sBox) sBtn.addEventListener('click', function () {
        var open = sBox.hidden;
        sBox.hidden = !open;
        sBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) { var i = sBox.querySelector('input[type=search]'); if (i) i.focus(); }
      });
      var mBtn = h.querySelector('[data-r-menu-toggle]');
      var drawer = h.querySelector('[data-r-drawer]');
      function closeMenu() {
        if (!drawer || drawer.hidden) return;
        drawer.hidden = true;
        document.body.classList.remove('r-drawer-open');
        if (mBtn) { mBtn.setAttribute('aria-expanded', 'false'); mBtn.focus(); }
      }
      if (mBtn && drawer) {
        mBtn.addEventListener('click', function () {
          drawer.hidden = false;
          document.body.classList.add('r-drawer-open');
          mBtn.setAttribute('aria-expanded', 'true');
          var c = drawer.querySelector('[data-r-menu-close]'); if (c) c.focus();
        });
        drawer.addEventListener('click', function (e) { if (e.target === drawer || e.target.closest('[data-r-menu-close]')) closeMenu(); });
        document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeMenu(); if (sBox && !sBox.hidden) { sBox.hidden = true; sBtn.setAttribute('aria-expanded', 'false'); } } });
      }
      var cart = h.querySelector('[data-r-cart-link]');
      if (cart) cart.addEventListener('click', function (e) {
        var cd = document.querySelector('cart-drawer');
        if (cd && typeof cd.open === 'function' && cd.dataset.cartType !== 'page') { e.preventDefault(); cd.open(cart); }
      });
    });
  }
  function setCartCount(n) {
    document.querySelectorAll('[data-r-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = !n;
      el.classList.remove('r-bump'); void el.offsetWidth; el.classList.add('r-bump');
      var link = el.closest('[data-r-cart-link]');
      if (link) link.setAttribute('aria-label', 'Warenkorb, ' + n + ' Artikel');
    });
  }
  function refreshCartCount() {
    fetch(((window.routes && window.routes.cart_url) || '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { setCartCount(c.item_count); })
      .catch(function () {});
  }
  R.refreshCartCount = refreshCartCount;
  if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS) {
    window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function () { refreshCartCount(); });
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS) window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function () { refreshCartCount(); });
    });
  }

  /* ---------- Ankündigung: auf dem Handy die Hinweise nacheinander zeigen ---------- */
  function initAnnounce(root) {
    (root || document).querySelectorAll('[data-rhoots-announce]').forEach(function (bar) {
      if (bar.dataset.ready) return;
      bar.dataset.ready = '1';
      var items = bar.querySelectorAll('.r-announce__item');
      if (items.length < 2) return;
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var i = 0;
      setInterval(function () {
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, 4000);
    });
  }

  /* ---------- Ritual-Quiz ---------- */
  function initQuiz(root) {
    (root || document).querySelectorAll('[data-rhoots-quiz]').forEach(function (q) {
      if (q.dataset.ready) return;
      q.dataset.ready = '1';
      var st = { step: 0, time: '', focus: '', exp: '' };
      var qs = q.querySelectorAll('[data-rq-question]');
      var res = q.querySelector('[data-rq-result]');
      var fill = q.querySelector('[data-rq-fill]');
      var bar = q.querySelector('[data-rq-bar]');
      var lbl = q.querySelector('[data-rq-step]');
      function prod(k) {
        var t = q.querySelector('template[data-rq-product="' + k + '"]');
        if (!t) return null;
        var c = t.content;
        return {
          media: c.querySelector('.r-quiz__img') ? c.querySelector('.r-quiz__img').innerHTML : '',
          title: (c.querySelector('[data-rq-title]') || {}).textContent || '',
          price: (c.querySelector('[data-rq-price]') || {}).textContent || '',
          url: ((c.querySelector('[data-rq-url]') || {}).textContent || '').trim()
        };
      }
      function render() {
        var done = st.step >= qs.length;
        qs.forEach(function (el, i) { el.hidden = i !== st.step; });
        res.hidden = !done;
        fill.style.width = Math.round(Math.min(st.step, qs.length) / qs.length * 100) + '%';
        bar.setAttribute('aria-valuenow', Math.min(st.step, qs.length));
        lbl.textContent = done ? 'Fertig' : 'Frage ' + (st.step + 1) + ' von ' + qs.length;
        if (!done) return;
        var kit = { calm: 1, flow: 1, glow: 1 }[st.focus] ? st.focus : '';
        var p, title, text;
        if (kit && st.exp === 'neu') {
          p = prod('set_' + kit) || prod(kit);
          title = prod('set_' + kit) ? p.title : 'Starter Kit + ' + (p ? p.title : 'Mini-Kit');
          text = 'Mit dem Starter Kit lernst du die Anwendung kennen, das Mini-Kit bringt die passende Anwendungskarte für dein Ritual mit.' + (prod('set_' + kit) ? '' : ' Auf der Produktseite wählst du «Mini-Kit + Starter Kit».');
        } else if (kit) {
          p = prod(kit); title = p ? p.title : 'Mini-Kit';
          text = 'Die passende Anwendungskarte und Seeds für dein Ritual. Du kennst dich ja schon aus.';
        } else if (st.exp === 'ja') {
          p = prod('refill'); title = p ? p.title : 'Refill Seeds';
          text = 'Nachschub aus 24K Gold für alle Anwendungskarten, die du schon kennst. Auch im 3er- und 6er-Pack.';
        } else {
          p = prod('starter'); title = p ? p.title : 'Starter Kit';
          text = 'Alles, was du für den Einstieg brauchst: 20 Seeds aus 24K Gold, 5 Anwendungskarten, Pinzette und Anleitung.';
        }
        q.querySelector('[data-rq-media]').innerHTML = p ? p.media : '';
        q.querySelector('[data-rq-rtitle]').textContent = title;
        q.querySelector('[data-rq-rtext]').textContent = text;
        q.querySelector('[data-rq-rprice]').textContent = p ? p.price : '';
        q.querySelector('[data-rq-rprice]').hidden = !p;
        var link = q.querySelector('[data-rq-rlink]');
        link.href = p ? p.url : '/collections/all';
        var gs = q.querySelector('[data-rq-guasha]');
        gs.hidden = !(st.time === 'morgens' && q.dataset.guashaUrl);
        res.focus({ preventScroll: true });
      }
      q.addEventListener('click', function (e) {
        var opt = e.target.closest('[data-rq-key]');
        if (opt) {
          opt.classList.add('is-picked');
          st[opt.dataset.rqKey] = opt.dataset.rqVal;
          setTimeout(function () { opt.classList.remove('is-picked'); st.step += 1; render(); }, 180);
          return;
        }
        if (e.target.closest('[data-rq-back]')) { st.step = Math.max(0, st.step - 1); render(); return; }
        if (e.target.closest('[data-rq-restart]')) { st = { step: 0, time: '', focus: '', exp: '' }; render(); }
      });
      render();
    });
  }

  function init(root) { initVideos(root); initSequences(root); initProduct(root); initReveal(root); initSliders(root); initHeader(root); initAnnounce(root); initQuiz(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  /* Theme-Editor: Sections neu initialisieren, wenn sie geändert werden */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
/* ---------- WARENKORB-FIX (Oktober 2026) ----------
   1. Warenkorb-Symbol im Rhoots Header öffnet den Warenkorb-Drawer statt der Warenkorb-Seite.
   2. «In den Warenkorb»-Knopf bei «Das könnte dir auch gefallen» im Drawer legt das Produkt
      direkt in den Warenkorb (Wonders Schnellkauf-Fenster bleibt mit unseren Produktseiten leer).
      Produkte mit mehreren Varianten öffnen die Produktseite. */
(function () {
  if (window.__rhootsCartFix) return;
  window.__rhootsCartFix = true;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var cartUrl = (window.routes && window.routes.cart_url) || '/cart';

  function ensureBubble() {
    if (!document.getElementById('cart-icon-bubble')) {
      var ph = document.createElement('div');
      ph.id = 'cart-icon-bubble';
      ph.hidden = true;
      document.body.appendChild(ph);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ensureBubble); else ensureBubble();

  function getDrawer() {
    var d = document.querySelector('cart-drawer');
    if (!d || d.dataset.cartType === 'page' || typeof d.toggleDrawerClasses !== 'function') return null;
    if (window.location.pathname === cartUrl) return null;
    return d;
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;

    /* 1. Warenkorb-Symbol */
    var link = e.target.closest('[data-r-cart-link]');
    if (link) {
      var d = getDrawer();
      if (!d) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      if (!d.isOpen) {
        if (typeof d.refreshCartDrawer === 'function') { try { d.refreshCartDrawer(); } catch (err) {} }
        d.toggleDrawerClasses();
      }
      return;
    }

    /* 2. Empfehlungen im Drawer */
    var btn = e.target.closest('.wt-cart__cross-sell quick-add button, .wt-cart__cross-sell .shoppable-video__add-button');
    if (!btn) return;
    var qa = btn.closest('quick-add');
    var handle = qa && qa.dataset.productHandle;
    if (!handle || !window.Rhoots || !window.Rhoots.addToCart) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (btn.classList.contains('is-loading')) return;
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');
    fetch(root + 'products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var avail = (p.variants || []).filter(function (v) { return v.available; });
        if ((p.variants || []).length !== 1 || !avail.length) {
          window.location = root + 'products/' + handle;
          return;
        }
        var fd = new FormData();
        fd.append('id', avail[0].id);
        fd.append('quantity', 1);
        return window.Rhoots.addToCart(fd, btn);
      })
      .catch(function () { window.location = root + 'products/' + handle; })
      .then(function () {
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-busy');
      });
  }, true);
})();

/* ---------- WARENKORB-ZIELE (Oktober 2026) ----------
   Fortschrittsbalken mit zwei Stationen im Warenkorb-Drawer und auf der Warenkorb-Seite:
   29 € = Gratisversand, 60 € = Gratis Refill (1 × 20 Seeds).
   Ab 60 € legt der Shop das Refill automatisch in den Warenkorb, darunter nimmt er es wieder heraus.
   Der Rabatt dafür ist in Shopify angelegt: «Gratis Refill ab 60 €» (automatischer Rabatt).
   Mini-Kits mit Set-Rabatt zählen nicht für das Geschenk (Shopify kombiniert das nicht). */
(function () {
  if (window.__rhootsShip) return;
  window.__rhootsShip = true;
  var SHIP = 2900;                          /* Gratisversand ab (Cent) */
  var GIFT = 6000;                          /* Gratis Refill ab (Cent) */
  var GIFT_VARIANT = 56513637089615;        /* Ohr-Akupressur Sticker 1 × 20 */
  var GIFT_NAME = 'Refill (20 Seeds)';
  var ONLY_COUNTRY = 'DE';
  var SUGGEST = ['seeding-pinzette', 're-fill-kit', 'ice-guasha-blau', 'calm-relax-mini-kit', 'the-essential-kit-24k-gold-ear-seeds'];

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
  var lastShip = null, lastGift = null, hadGift = false, busy = false, products = null, timer = null;
  var declined = false;
  try { declined = sessionStorage.getItem('rhootsGiftDeclined') === '1'; } catch (e) {}

  function money(c) { return window.Rhoots && Rhoots.money ? Rhoots.money(c) : (c / 100).toFixed(2).replace('.', ',') + ' €'; }
  function short(c) { return money(c).replace(/[,.]00(?=\D*$)/, ''); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m]; }); }
  function countryOk() { if (!ONLY_COUNTRY) return true; var c = window.Shopify && Shopify.country; return !c || c === ONLY_COUNTRY; }

  var TRUCK = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" aria-hidden="true"><path d="M2.5 6.5h11v9h-11zM13.5 9.5h4l3 3v3h-7z"/><circle cx="6.5" cy="17.5" r="1.6"/><circle cx="17" cy="17.5" r="1.6"/></svg>';
  var BOX = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true"><path d="M3 6h11v9H3zM14 9h4l3 3v3h-7"/></svg>';
  var GIFTI = '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true"><path d="M4 11h16v9H4zM3 7.5h18V11H3zM12 7.5V20M12 7.5S10.5 3.5 8 4.2 8.5 7.5 12 7.5zm0 0s1.5-4 4-3.3S15.5 7.5 12 7.5z"/></svg>';
  var CHECK = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.2" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';

  function isGiftLine(i) { return i.variant_id === GIFT_VARIANT && i.properties && i.properties.Geschenk; }
  function hasSetDiscount(i) {
    return (i.line_level_discount_allocations || []).some(function (d) {
      return d.amount > 0 && d.discount_application && /^Mini-Kit Set/i.test(d.discount_application.title || '');
    });
  }
  function eligible(cart) {
    return (cart.items || []).reduce(function (s, i) {
      if (isGiftLine(i) || hasSetDiscount(i)) return s;
      if (i.variant_id === GIFT_VARIANT) return s;   /* das Refill selbst zählt nicht mit */
      return s + i.final_line_price;
    }, 0);
  }

  function loadProducts() {
    if (products) return Promise.resolve(products);
    return Promise.all(SUGGEST.map(function (h) {
      return fetch(root + 'products/' + h + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (l) { products = l.filter(Boolean); return products; });
  }
  function pick(rest, cart) {
    if (!products || rest <= 0) return null;
    var inCart = {};
    (cart.items || []).forEach(function (i) { inCart[i.handle] = true; });
    var o = [];
    products.forEach(function (p) { (p.variants || []).forEach(function (v) { if (v.available && v.id !== GIFT_VARIANT) o.push({ p: p, v: v, fresh: !inCart[p.handle] }); }); });
    var fits = o.filter(function (x) { return x.v.price >= rest; });
    var pool = fits.filter(function (x) { return x.fresh; });
    if (!pool.length) pool = fits;
    if (pool.length) return pool.sort(function (a, b) { return a.v.price - b.v.price; })[0];
    return o.sort(function (a, b) { return b.v.price - a.v.price; })[0] || null;
  }

  function confetti(box) {
    if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var colors = ['#EFFF33', '#2B2326', '#F2C6D0', '#BCCDEB', '#FFFFFF'];
    var w = document.createElement('div'); w.className = 'r-ship__confetti';
    for (var i = 0; i < 28; i++) {
      var s = document.createElement('i');
      s.style.left = (Math.random() * 100) + '%'; s.style.background = colors[i % colors.length];
      s.style.setProperty('--dx', (Math.random() * 120 - 60) + 'px');
      s.style.setProperty('--dy', (-40 - Math.random() * 70) + 'px');
      s.style.setProperty('--rot', (Math.random() * 540 - 270) + 'deg');
      s.style.animationDelay = (Math.random() * 0.15) + 's';
      w.appendChild(s);
    }
    box.appendChild(w); setTimeout(function () { w.remove(); }, 1600);
  }

  function view(cart) {
    var total = cart.total_price || 0;
    var elig = eligible(cart);
    var shipOk = total >= SHIP;
    var giftOk = elig >= GIFT;
    var setBlock = !giftOk && total >= GIFT && (cart.items || []).some(hasSetDiscount);
    var stationPct = Math.round(SHIP / GIFT * 100);
    var pct = giftOk ? 100 : Math.min(99, Math.round(Math.min(total, GIFT) / GIFT * 100));
    var msg, rest = 0;
    if (!shipOk) { rest = SHIP - total; msg = 'Noch <strong>' + money(rest) + '</strong> bis zum Gratisversand.'; }
    else if (!giftOk) {
      rest = GIFT - elig;
      msg = setBlock
        ? '<b>Gratisversand ✓</b> Das Gratis-Refill gibt es nicht zusätzlich zum Mini-Kit-Set-Rabatt.'
        : '<b>Gratisversand ✓</b> Noch <strong>' + money(rest) + '</strong> bis zum gratis ' + GIFT_NAME + '.';
    } else msg = '<strong>Geschafft!</strong> Gratisversand und ein ' + GIFT_NAME + ' gratis dazu.';
    var s = (!giftOk && !setBlock) ? pick(rest, cart) : null;
    var sug = '';
    if (s) {
      var name = (s.p.title || '').replace(/[\u{1F300}-\u{1FAFF}☀-➿]/gu, '').replace(/['‘’]/g, '').trim();
      if (s.p.variants.length > 1 && s.v.title && s.v.title !== 'Default Title') name += ' · ' + s.v.title.replace(/\s*\(.*\)$/, '');
      var img = s.p.featured_image ? s.p.featured_image + (s.p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=96' : '';
      sug = '<div class="r-ship__tip">' + (img ? '<img src="' + esc(img) + '" alt="" width="40" height="40" loading="lazy">' : '') +
        '<span class="r-ship__tip-text">' + (s.v.price >= rest ? 'Damit hast du es: ' : 'Bringt dich näher: ') + '<strong>' + esc(name) + '</strong> ' + money(s.v.price) + '</span>' +
        '<button type="button" class="r-ship__add" data-r-ship-add="' + s.v.id + '" aria-label="' + esc(name) + ' in den Warenkorb">+</button></div>';
    }
    function station(at, icon, ok, label) {
      return '<span class="r-ship__stop' + (ok ? ' is-done' : '') + '" style="left:' + at + '%" title="' + esc(label) + '">' + (ok ? CHECK : icon) + '</span>';
    }
    return {
      ship: shipOk, gift: giftOk, elig: elig,
      key: [total, elig, s ? s.v.id : '', setBlock].join('|'),
      markup:
        '<p class="r-ship__msg" aria-live="polite">' + msg + '</p>' +
        '<div class="r-ship__track" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + pct + '" aria-label="Fortschritt bis zu den Warenkorb-Zielen">' +
          '<div class="r-ship__fill" style="width:' + pct + '%"></div>' +
          station(stationPct, BOX, shipOk, 'Gratisversand ab ' + short(SHIP)) +
          station(100, GIFTI, giftOk, GIFT_NAME + ' gratis ab ' + short(GIFT)) +
          '<span class="r-ship__truck" style="left:' + pct + '%">' + TRUCK + '</span>' +
        '</div>' +
        '<div class="r-ship__scale"><span style="left:' + stationPct + '%">' + short(SHIP) + ' · Versand</span><span style="left:100%">' + short(GIFT) + ' · Refill</span></div>' +
        sug
    };
  }

  function mountPoints() {
    var pts = [];
    var body = document.querySelector('cart-drawer .wt-cart__drawer__body');
    if (body && document.querySelector('cart-drawer .wt-cart__list')) pts.push({ parent: body, id: 'drawer' });
    var page = document.querySelector('.cart-page .wt-cart__body') || (document.querySelector('.cart-page .wt-cart__list') || {}).parentElement;
    if (page && window.location.pathname === cartUrl) pts.push({ parent: page, id: 'page' });
    return pts;
  }

  function afterCartChange() {
    if (window.location.pathname === cartUrl) { window.location.reload(); return; }
    document.dispatchEvent(new CustomEvent('cart-drawer:refresh'));
    if (window.Rhoots && Rhoots.refreshCartCount) Rhoots.refreshCartCount();
  }

  /* Geschenk automatisch hinzufügen oder entfernen */
  function syncGift(cart, v) {
    if (busy) return false;
    var line = (cart.items || []).filter(isGiftLine)[0];
    var paid = (cart.items || []).some(function (i) { return i.variant_id === GIFT_VARIANT && !isGiftLine(i); });
    if (hadGift && !line && v.gift) { declined = true; try { sessionStorage.setItem('rhootsGiftDeclined', '1'); } catch (e) {} }
    hadGift = !!line;
    var req = null;
    if (v.gift && !line && !paid && !declined) {
      req = fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: GIFT_VARIANT, quantity: 1, properties: { Geschenk: 'ab ' + short(GIFT) } }] }) });
      hadGift = true;
    } else if (!v.gift && line) {
      req = fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: line.key, quantity: 0 }) });
      hadGift = false;
    } else if (line && line.quantity > 1) {
      req = fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: line.key, quantity: 1 }) });
    }
    if (!req) return false;
    busy = true;
    req.then(function () { busy = false; afterCartChange(); }, function () { busy = false; });
    return true;
  }

  function render() {
    if (!countryOk()) return;
    if (!mountPoints().length) return;
    fetch(cartUrl + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { return loadProducts().then(function () { return cart; }, function () { return cart; }); })
      .then(function (cart) {
        var v = view(cart);
        if (syncGift(cart, v)) return;
        var crossed = (lastShip === false && v.ship) || (lastGift === false && v.gift);
        lastShip = v.ship; lastGift = v.gift;
        mountPoints().forEach(function (pt) {
          var box = pt.parent.querySelector(':scope > .r-ship');
          if (!cart.item_count) { if (box) box.remove(); return; }
          if (!box) { box = document.createElement('div'); box.className = 'r-ship r-ship--' + pt.id; pt.parent.insertBefore(box, pt.parent.firstElementChild); }
          if (box.dataset.key !== v.key) { box.innerHTML = v.markup; box.dataset.key = v.key; }
          box.classList.toggle('is-ship', v.ship);
          box.classList.toggle('is-won', v.gift);
          if (crossed) { box.classList.add('is-pop'); confetti(box); setTimeout(function () { box.classList.remove('is-pop'); }, 900); }
        });
      })
      .catch(function () {});
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(render, 150); }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-r-ship-add]');
    if (!b || !window.Rhoots || !Rhoots.addToCart) return;
    e.preventDefault();
    if (b.classList.contains('is-loading')) return;
    b.classList.add('is-loading');
    var fd = new FormData();
    fd.append('id', b.getAttribute('data-r-ship-add'));
    fd.append('quantity', 1);
    Rhoots.addToCart(fd, b).then(function () {
      if (window.location.pathname === cartUrl) window.location.reload(); else schedule();
    }).catch(function () { b.classList.remove('is-loading'); });
  });

  function observe() {
    var targets = [document.querySelector('cart-drawer'), document.querySelector('.cart-page')].filter(Boolean);
    var mo = new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) {
        var t = list[i].target;
        if (t.closest && t.closest('.r-ship')) continue;
        schedule(); return;
      }
    });
    targets.forEach(function (t) { mo.observe(t, { childList: true, subtree: true }); });
    if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS) window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, schedule);
    document.addEventListener('cart-drawer:refresh', schedule);
    schedule();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observe); else observe();
})();
